import trackAddRemoveFromBasket from './track-add-remove-from-basket'

const trackAddToBasket = (identifier, context) => trackAddRemoveFromBasket('add', identifier, context)

export default trackAddToBasket
